var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-cabinet-referral-info-list-payment-status",class:{
        _accented: _vm.code === 'paid',
    }},[_c('div',{staticClass:"page-cabinet-referral-info-list-payment-status__text",domProps:{"textContent":_vm._s(_vm.statusText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }